export default {"src":"/_next/static/media/gv-icon.72db9141.svg","height":27,"width":45,"blurWidth":0,"blurHeight":0};